import { GatsbyImage } from "gatsby-plugin-image";
import React from 'react';
import Button from '../../../shared/components/atoms/button/button';
import './section-buy-in.scss';

const SectionBuyIn = ({ alliesData }) => {

    return (
        <section className="f-m-buy-in">
            <div className="f-m-buy-in__content">
                <h2 className="f-m-buy-in__title">
                    Compra pequeñín en:
                </h2>
                <div className="f-m-buy-in__allies-container">
                    {alliesData &&
                        alliesData.map((info, index) => {
                            return (
                                <a key={index} className="f-m-buy-in__ally-card" href={info.redireccionRetailer} target="__blank" rel="noopener noreferrer">
                                    <div className="f-m-buy-in__ally-image-container">
                                        <GatsbyImage
                                            image={info.imagenRetailer.gatsbyImageData}
                                            alt={info.imagenRetailer.description}
                                            className="f-m-buy-in__ally-image"
                                        />
                                    </div>
                                    <Button className="f-a-button__primary-blue f-a-button__small f-m-buy-in__ally-button"
                                        copy={info.nombreCta}
                                    />
                                </a>
                            )
                        })
                    }
                </div>
            </div>
        </section>
    )
}

export default SectionBuyIn
